// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1486":"10db497cb054a9d6","5343":"e8dec88c07714f4b","8930":"bb9efb70525886a4"}[chunkId] + ".css";
};